<template>
  <div class="p_b home">
    <!--顶部轮播-->
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="(item,index) in topBanner" :key="index" @click="goToOut(item)">
        <van-image fit="cover" :src="item.imgUrl"/>
      </van-swipe-item>
    </van-swipe>
    <div class="h_menu">
      <!--四个菜单-->
      <div class="h_menu_top d_f ali_c j_s">
        <div class="t_a cur_p" v-for="(item,index) in menuInfo" :key="index" @click="enter(item.linkUrl,item.bannerCode)">
          <img :src="item.imgUrl" alt="">
          <div>{{item.bannerName}}</div>
        </div>
      </div>
      <!--电话图片-->
      <div class="h_phone" @click="goToOut(phoneInfo,1)">
        <img :src="phoneInfo.coverUrl" alt="" class="full_w">
      </div>
    </div>
    <!-- 师资力量 -->
    <div class="Faculty">
      <div class="title">
        <h4>师资力量</h4>
        <span @click="allFaculty('/Faculty')">全部<van-icon name="arrow" /></span>
      </div>
      <ul class="list">
        <li v-for="item in teaching" :key="item.teacherId" @click="detailFaculty(item.teacherId)">
          <img :src="item.picUrl" alt="">
          <h6>{{item.teacherName}}</h6>
          <p>{{item.synopsis.replace(/<\/?.+?\/?>/g,'')}}</p>
        </li>
      </ul>
    </div>
    <!-- 教学展示 -->
    <div class="teaching">
      <div class="title">
        <h4>教学展示</h4>
        <span @click="allFaculty('/Teaching')">全部<van-icon name="arrow" /></span>
      </div>
      <ul class="list">
        <li v-for="item in list" :key="item.commodityId" @click="detailTeaching(item.contentId)">
          <img :src="item.coverUrl" alt="">
          <div>
            <h6>{{item.title}}</h6>
            <p>{{item.synopsis}}</p>
          </div>
        </li>
      </ul>
    </div>
    <!--底部菜单-->
    <FootTab :ac="1"></FootTab>
  </div>
</template>

<script>
  export default {
    name: 'Home',
    data() {
      return {
        teaching:[],//师资力量列表
        topBanner:[],
        menuInfo:[],
        ydInfo:{contentInfo:''},

        refreshing:false,
        loading:true,
        finished:false,
        list:[],
        params:{
          columnCode: "jxzs",
          pageIndex:1,
          pageSize:6,
        },
        params2:{
          pageIndex:1,
          pageSize:6,
        },
        phoneInfo:{},
      }
    },
    created(){
      /*this.$api.login({
        "phoneNumber":"18908025312",
        "verifyCode":"123"
      }).then(res => {
        console.log(res)
      })*/
      this.getBanner(2);
      this.getBanner(3);
      // this.queryContentByCode();
      this.listCommodity();
      this.listTeacher()
      this.listVideo()
    },
    methods: {
      listVideo(){
        this.$api.listVideo({pageIndex:1,pageSize:1}).then(res => {
          this.phoneInfo = res.data.rows[0]
          console.log(this.phoneInfo)
        })
      },
      // 跳转列表页
      allFaculty(item){
        this.$router.push(item)
      },
      enter(item,code){
        this.$router.push(`${item}?code=${code}`)
      },
      // 跳转到详情页
      detailFaculty(item){
        this.$router.push(`/FacultyDetail?teacherId=${item}`)
      },
      detailTeaching(item){
        this.$router.push(`/TeachingDetail?contentId=${item}`)
      },
      // 师资力量
      listTeacher(){
        this.$api.listTeacher(this.params2).then(res => {
          if(res.status ==1){
            this.teaching = res.data.rows
          }else{
            this.$toast(res.message);
          }


        })
      },
      //banner跳转外链
      goToOut(row,num){
        if(num){
          if(row.videoUrl) window.location.href=row.videoUrl;
        }else{
          if(row.linkUrl) window.location.href=row.linkUrl;
        }
      },
      // 根据code获取课程
      listCommodity(){
        this.loading = true;
        this.$api.listContent(this.params).then(res => {
          this.loading = false;
          if (this.refreshing) {
            this.refreshing = false;
          }
          if(res.data.recordCount){
            this.list = this.list.concat(JSON.parse(JSON.stringify(res.data.rows)));
          }
          let list = res.data.rows;
          if (!list || list.length < this.params.pageSize) {
            this.finished = true;
          }
        })
      },
      // //查询预定须知
      // queryContentByCode(){
      //   this.$api.queryContentByCode('ydxz').then(res => {
      //     this.ydInfo = JSON.parse(JSON.stringify(res.data));
      //   })
      // },
      //获取顶部banner1，四个菜单3
      getBanner(num){
        this.$api.listBanner({pageIndex:1,pageSize:100,position:num}).then(res => {
          // console.log(res);

          let data = JSON.parse(JSON.stringify(res.data.rows));

          if(num == 2){
            this.topBanner = data;
          }
          if(num == 3){
            this.menuInfo = data;
          }
        })
      },

      onRefresh(){
        this.list = [];
        this.finished = false;
        this.params.pageIndex = 1;
        this.listCommodity();
      },
      onLoad(){
        let me = this;
        if(me.loading) return
        let page = me.params.pageIndex;
        page = page ? page + 1 : 1;
        this.params.pageIndex = page;
        this.listCommodity();
      },
    }
  }
</script>
<style scoped lang="scss">
  .home{
    .hot_out{
      .hot_content{
        .hot_item{
          .price{
            .num{
              font-size: 10px;
              font-weight: bold;
              color: #B7B7B7;
            }
            font-size: 15px;
            font-weight: bold;
            color: #FF6C00;
          }
          .hi_title{
            margin-bottom: 9px;
            font-size: 13px;
            font-weight: bold;
            color: #333333;
            .d_i{
              display: block;
              width: 45px;
              height: 15px;
              background: #25BDDE;
              border-radius: 5px 0px 5px 0px;
              font-size: 9px;
              font-weight: 500;
              color: #FFFFFF;
              text-align: center;
              line-height: 15px;
              margin-top: 4px;
              /*margin-left: 4px;*/
              &.red{
                background-color: #FD5D70;
              }
              &.blue{
                background-color: #25BDDE;
              }
              &.green{
                background-color: #39C658;
              }
            }
          }
          .banner{
            border-radius: 10px;
            width: 100%;
            height: 115px;
            margin-bottom: 4px;
          }
          width: calc(50% - 5px);
          margin-bottom: 20px;
          display: inline-block;
          &:nth-child(odd){
            margin-right: 10px;
          }
        }
        padding: 0 12px;
      }
      .ho_title{
        .hot_text{
          font-size: 18px;
          font-weight: bold;
          color: #333333;
          width: 100%;
          left: 0;
          top: 18px;
          .d_i{
            width: 85px;
            background-color: white;
          }
        }
        .cut2{
          font-size: 0;
        }
        .cut22{
          width: 50%;
          height: 1px;
          border-bottom: 1px solid #B2B2B2;
        }
        .cut1{
          margin-bottom: 5px;
          height: 1px;
          border-bottom: 1px solid #B2B2B2;
        }
        margin-bottom: 20px;
        padding-top: 27px;
      }
      background-color: white;
    }
    .h_menu{
      .h_phone{
        margin-top: 24px;
        /*height: 65px;*/
      }
      .h_menu_center{
        .go_icon{
          width: 14px;
          height: 14px;
          margin-top: 4px;
        }
        .hmc_r1{
          margin-bottom: 9px;
        }
        .hmc_r1,.hmc_r2{
          width: 170px;
          height: 85px;
          .p_a{
            padding: 10px;
          }
        }
        .p_a{
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          box-sizing: border-box;
          line-height: 1;
        }
        .br{
          width: 98px;
          height: 20px;
          line-height: 20px;
          box-sizing: border-box;
          margin-top: 6px;
          background: rgba(0, 0, 0, 0.2);
          border-radius: 10px;
          font-size: 10px;
          text-align: center;
          font-weight: bold;
          color: #FFFFFF;
          text-shadow: none;
        }
        .hmc_l{
          .p_a{
            padding: 17px 11px;
          }
          width: 170px;
          height: 180px;
          margin-right: 10px;
        }
        width: 100%;
        margin-top: 10px;
        font-size: 20px;
        font-weight: bold;
        color: #FFFFFF;
        text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.34);
      }
      .h_menu_top{
        img{
          width: 52px;
          height: 52px;
          margin-bottom: 5px;
        }
        font-size: 15px;
        font-weight: 500;
        color: #333333;
      }
      padding: 10px 16px 15px;
      border-bottom: 10px solid #F0F0F0;
    }
    .order{
      img{
        width: 23px;
        height: 23px;
        margin-right: 4px;
      }
      .tip{
        font-size: 15px;
        font-weight: bold;
        color: #25BDDE;
      }
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      height: 40px;
      background: #DDF9FF;
      padding: 0 13px;
      line-height: 40px;
    }
  }


  .teaching{
    background: #f0f0f0;
    padding:0 13px 15px;
    .list li{
      margin-bottom: 8px;
      background: #fff;
      height: 100px;
      padding: 10px;
      border-radius: 10px;
      display: flex;
      img{
        width: 160px;
        height: 100px;
      }
      >div{
        width: 155px;
        margin-left: 13px;
        padding-top: 8px;
        h6{
          font-size: 14px;
        }
        p{
          margin-top: 17px;
          color: #9d9d9d;
          font-size: 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
    .title{
      display: flex;
      margin-bottom: 10px;
      h4{
        font-size: 17px;
      }
      span{
        display: block;
        margin-left: auto;
        color:#6b6b6b;
        font-size: 14px;
      }
    }
  }

  .Faculty{
    background: #f0f0f0;
    padding: 15px 13px;
    .list{
      display: flex;
      flex-wrap: wrap;
      margin-top: 10px;
      li:nth-child(3n+2){
        margin: 0 8px;
      }
      li{
        width: 110px;
        height: 145px;
        background: #fff;
        border-radius: 6px;
        overflow: hidden;
        margin-bottom: 7px;
        img{
          width: 66px;
          height: 66px;
          display: block;
          border-radius: 50%;
          margin: 10px auto 0;
        }
        h6{
          font-size: 14px;
          text-align: center;
          margin-top: 5px;
          margin-bottom: 3px;
        }
        p{
          color: #9d9d9d;
          font-size: 10px;
          padding: 0 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
    .title{
      display: flex;
      h4{
        font-size: 17px;
      }
      span{
        display: block;
        margin-left: auto;
        color:#6b6b6b;
        font-size: 14px;
      }
    }
  }
</style>
